var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-content",class:{half: _vm.half}},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"material-icons icon-i"},[_vm._v(_vm._s(_vm.icon || "gesture"))])]),_c('div',{staticClass:"message"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }